import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber, FormattedPlural } from 'react-intl';
import { Tooltip, TooltipData } from '../../../../elements-tooltip/tooltip';
import { getCurrencyFromListing } from '../../utils/get-currency-from-listing';
import { isOfferState } from '../../utils/is-offer-state';

const getSubtotalLabel = (booking, listing) => {
  const currency = getCurrencyFromListing(listing);
  const customPrice = (booking.payout || booking.payment)?.custom;

  if (customPrice) {
    return (
      <FormattedMessage
        id="inbox.create_calculator.custom_price"
        defaultMessage="Custom price"
      />
    );
  }

  if (isOfferState(booking)) {
    return (
      <FormattedMessage
        id="inbox.create_calculator.subtotal"
        defaultMessage="Subtotal"
      />
    );
  }

  if (listing.fandb_required) {
    return (
      <span>
        <FormattedNumber
          value={booking.rate || 0}
          currency={currency}
          style="currency"
        />{' '}
        x {booking.duration} hr
        <br />
        <FormattedPlural
          value={booking.duration || 0}
          other={
            listing.fandb_applies_to === 'FOOD_BEV' ? (
              <FormattedMessage
                id="inbox.create_calculator.food_and_bar"
                defaultMessage="food and bar tab"
              />
            ) : (
              <FormattedMessage
                id="inbox.create_calculator.bar"
                defaultMessage="bar tab"
              />
            )
          }
        />
      </span>
    );
  }

  return (
    <span>
      <FormattedNumber
        value={booking.rate || 0}
        currency={currency}
        style="currency"
      />{' '}
      x {booking.duration || 0}{' '}
      <FormattedPlural
        value={booking.duration || 0}
        one={
          <FormattedMessage
            id="inbox.create_calculator.hour"
            defaultMessage="hour"
          />
        }
        other={
          <FormattedMessage
            id="inbox.create_calculator.hours"
            defaultMessage="hours"
          />
        }
      />
    </span>
  );
};

export const PriceBreakdownSubtotal = ({ booking, listing }) => {
  const currency = getCurrencyFromListing(listing);
  return (
    <div
      className="flex space-between"
      data-testing-id="price-breakdown-subtotal"
    >
      <span data-testing-id="price-breakdown-subtotal-label">
        {getSubtotalLabel(booking, listing)}
        <span className="margin-sm-left">
          <Tooltip
            tooltip={TooltipData.VARIABLE_PRICING(
              listing,
              booking.rate_details
            )}
          />
        </span>
      </span>
      <span data-testing-id="price-breakdown-subtotal-amount">
        <FormattedNumber
          value={booking.subtotal_amount || 0}
          currency={currency}
          style="currency"
        />
      </span>
    </div>
  );
};

PriceBreakdownSubtotal.propTypes = {
  booking: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired
};
